import { render, staticRenderFns } from "./patientPrescribeDetailModal.vue?vue&type=template&id=2097db39"
import script from "./patientPrescribeDetailModal.vue?vue&type=script&lang=js"
export * from "./patientPrescribeDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports